import styled from 'styled-components';
import { Box } from '../../../../CommonComponents/OPL/Box/Box';

export const TrustsList = styled(Box)(({ theme }) => ({
  border: `1px solid ${theme.colors.neutral['200']}`,
  borderRadius: theme.radii.medium,
  padding: 0,
}));

export const TrustItem = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '6px 8px 6px 16px',
  borderTop: `1px solid ${theme.colors.neutral['200']}`,

  '&:first-of-type': {
    borderTop: 'none',
  },
}));

export const Actions = styled(Box)({
  display: 'flex',
  flexShrink: 0,
  alignItems: 'center',
  marginLeft: 24,
});
